import * as React from 'react';

import { Search } from '@weddingspot/ws-api-client';
import { useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FeatureFlagContext, VENUE_STYLE_AND_WAFFLE_FLAG_MAPPING_DICT } from '@weddingspot/ws-core-components';

const _styles = require('./LinkFarm.scss');

function LinkFarmSection(props: { data: Search.LinkFarmSection }) {
    const [isSectionExpanded, setIsSectionExpanded] = useState(false);
    const { flagEnabled } = React.useContext(FeatureFlagContext);

    return (
        <div className={_styles.section}>
            <h2 className={_styles.sectionTitle}>{props.data.section_name}</h2>
            <div className={_styles.sectionContent}>
                {props.data.links.map((url: Search.RelativeUrl, idx: number) =>
                    VENUE_STYLE_AND_WAFFLE_FLAG_MAPPING_DICT[url.label.replace(' Weddings', '')] == undefined ||
                    !flagEnabled(VENUE_STYLE_AND_WAFFLE_FLAG_MAPPING_DICT[url.label.replace(' Weddings', '')]) ? (
                        <div key={idx} className={classNames(_styles.link, { [_styles.hidden]: idx > 2 && !isSectionExpanded })}>
                            <Link
                                to={url.url}
                                onClick={() => {
                                    window.scrollTo(0, 100);
                                }}
                            >
                                {url.label}
                            </Link>
                        </div>
                    ) : null
                )}
            </div>
            {props.data.links.length > 3 && (
                <div className={_styles.seeMoreLink} onClick={() => setIsSectionExpanded((s) => !s)}>
                    {isSectionExpanded ? 'See less' : 'See more...'}
                </div>
            )}
        </div>
    );
}

export const LinkFarm = (props: { data: Search.LinkFarmSection[] }) => {
    return (
        <div className={_styles.farm}>
            {props.data.map((section: Search.LinkFarmSection, idx: number) => (
                <LinkFarmSection key={idx} data={section} />
            ))}
        </div>
    );
};
